/**
 * Public API helper — no auth, no interceptors. Used for token-scoped endpoints
 * like /api/id-verify/{token}.
 */
import axios from "axios";

export const publicApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
    timeout: 30000,
});
